import React from 'react';
import PropType from 'prop-types';
import Icon from '../../../00_atoms/icon/Icon';

/*
 * On Air Module
 * ---------------------
 * This small module appears in the bottom right/RHS, and shows the currently playing song (or radio show, if a podcast is playing)
 */

class AudioPlayerComponentOnAir extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const dataActiveShow = this.props.dataActiveShow;
    const dataSong = this.props.dataSong;
    const audioState = this.props.audioState;
    const isExpanded = this.props.isExpanded;
    let logo = this.props.logo;

    const ihrUrl = window.siteData.ihrStationUrl;
    let link = `https://www.iheart.com/`;
    if (ihrUrl) {
      link = ihrUrl;
    }
    link = `${link}?utm_source=arnSite&utm_medium=AudioPlayer&utm_campaign=${
      window.siteData.identity
    }`;

    let artwork = dataSong && dataSong.imagePath ? dataSong.imagePath : '';
    if (dataSong.imagePath) {
      const base64Url = btoa(artwork);
      artwork = `https://i.iheart.com/v3/url/${base64Url}?ops=fit(200,200)`;
    }

    let type =
      dataSong && dataSong.intro ? dataSong.intro : 'Listen to more on';

    let name = 'iHeartRadio';

    if (dataSong && dataSong.title) {
      name = dataSong.title;
      if (dataSong.artist) {
        name += `, ${dataSong.artist}`;
      }
    }

    if (audioState === 'podcast on' || audioState === 'podcast off') {
      artwork = dataActiveShow.art;
      type = 'ON AIR';
      name = dataActiveShow.show_name;
      if (name === null) name = '';
      link = 'javascript:window.playLiveStream();';
    }

    if (
      dataSong &&
      dataSong.artistId &&
      dataSong.artistId !== -1 &&
      dataSong.artistId !== '-1'
    ) {
      link = `https://www.iheart.com/artist/${
        dataSong.artistId
      }/?utm_source=arnSite&utm_medium=AudioPlayer&utm_campaign=${
        window.siteData.identity
      }`;
    }

    let nameTruncated = name;
    if (name.length > 32) {
      nameTruncated = `${name.substring(0, 29)}...`;
    }

    if (!logo) {
      logo = `/wp-content/themes/arn/assets/img/iheart_kiis_1065.png`;
    }

    const colAClasses = isExpanded
      ? `col col-5 col-md-6 u-d-lg-none u-pr-0`
      : `col u-d-none`;
    const colBClasses = `col u-d-none u-d-lg-block u-d-xl-block col-lg-2`; // ART MODULE
    const colBStyle = {
      padding: 0,
      fontSize: '58px',
    };
    const colCClasses = isExpanded
      ? `col  col-7 col-md-6 col-lg-8 u-pl-0`
      : `col col-12 col-lg-8`; // NAME MODULE

    const componentClasses = isExpanded
      ? `row po-audio-player__component-on-air po-audio-player__component-on-air--is-expanded`
      : `row po-audio-player__component-on-air  po-audio-player__component-on-air--is-minified`;

    if (type && name) {
      return (
        <div className={componentClasses}>
          <div className={colAClasses}>
            <div className={`po-audio-player__ihr`}>
              <div>
                <img
                  src={logo}
                  className={`po-audio-player__ihr__logo`}
                  alt={`Powered By I Heart Radio`}
                />
              </div>
            </div>
          </div>

          <div className={colCClasses}>
            <div>
              <span className={`po-audio-player__component-on-air__type`}>
                {type}
              </span>
            </div>
            <div>
              <span
                className={`po-audio-player__component-on-air__name`}
                title={name}
              >
                <a href={link} target="_blank" rel="noopener noreferrer">
                  {nameTruncated}
                </a>
              </span>
            </div>
          </div>

          <div className={colBClasses} style={colBStyle}>
            {artwork ? (
              <div
                className={`po-audio-player__component-on-air__image-container`}
              >
                <a href={link} target="_blank" rel="noopener noreferrer">
                  <img
                    className={`po-audio-player__component-on-air__image`}
                    src={artwork}
                    alt={''}
                  />
                </a>
              </div>
            ) : (
              <a href={link} target="_blank" rel="noopener noreferrer">
                <Icon
                  iconName={`icon-iHeart`}
                  iconTitle={`iHeart`}
                  iconClass={`po-audio-player__component-on-air__icon`}
                  xLink={`/wp-content/themes/arn/assets/icons/icons.svg`}
                />
              </a>
            )}
          </div>
        </div>
      );
    }

    return '';
  }
}

AudioPlayerComponentOnAir.propTypes = {
  dataActiveShow: PropType.object.isRequired,
  audioState: PropType.string.isRequired,
  dataSong: PropType.object.isRequired,
  isExpanded: PropType.bool.isRequired,
  logo: PropType.string.isRequired,
};

export default AudioPlayerComponentOnAir;
